import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { surviveTreeShaking } from '@df/ng/survive-tree-shaking';
import { CatalogCommonModule } from '../catalog/catalog-common.module';
import { SharedModule } from '../shared.module';
import { PageFooterNewsletterFormComponent } from './footer/newsletter-form/page-footer-newsletter-form.component';
import { PageFooterComponent } from './footer/page-footer.component';
import { PageHeaderBasketQtyBulletDirective } from './header/basket-qty-bullet/page-header-basket-qty-bullet.directive';
import { PageHeaderMaganavContentAreaDirective } from './header/meganav/content/area/page-header-meganav-content-area.directive';
import { PageHeaderMeganavContentItemComponent } from './header/meganav/content/item/page-header-meganav-content-item.component';
import { PageHeaderMeganavContentComponent } from './header/meganav/content/page-header-meganav-content.component';
import { PageHeaderMeganavMenuComponent } from './header/meganav/menu/page-header-meganav-menu.component';
import { PageHeaderComponent } from './header/page-header.component';
import { PageHeaderPromobarCoutdownComponent } from './header/promobar/countdown/page-header-promobar-coutdown.component';
import { PageHeaderPromobarComponent } from './header/promobar/page-header-promobar.component';
import { PageHeaderSearchFormComponent } from './header/search-form/page-header-search-form.component';
import { PageHeaderWishlistQtyBulletDirective } from './header/wishlist-qty/page-header-wishlist-qty-bullet.directive';
import { PageOffCanvasMenuComponent } from './off-canvas/menu/page-off-canvas-menu.component';
import { PageOffCanvasComponent } from './off-canvas/page-off-canvas.component';
import { PageOffCanvasSearchFormComponent } from './off-canvas/search-form/page-off-canvas-search-form.component';
import { PageSearchOutletComponent } from './search/outlet/page-search-outlet.component';

@NgModule({
    imports: [SharedModule, CommonModule, CatalogCommonModule],
    declarations: [
        PageFooterComponent,
        PageFooterNewsletterFormComponent,
        PageHeaderBasketQtyBulletDirective,
        PageHeaderComponent,
        PageHeaderMaganavContentAreaDirective,
        PageHeaderMeganavContentComponent,
        PageHeaderMeganavContentItemComponent,
        PageHeaderMeganavMenuComponent,
        PageHeaderPromobarComponent,
        PageHeaderPromobarCoutdownComponent,
        PageHeaderSearchFormComponent,
        PageSearchOutletComponent,
        PageHeaderWishlistQtyBulletDirective,
        PageOffCanvasComponent,
        PageOffCanvasMenuComponent,
        PageOffCanvasSearchFormComponent
    ],
    exports: [PageHeaderComponent, PageFooterComponent, PageOffCanvasComponent]
})
export class PageModule {
    constructor() {
        surviveTreeShaking(PageHeaderMeganavContentItemComponent);
    }
}
